// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* switchMedia.css */

/* ========================================
   LOCAL TOKENS
   ======================================== */

:root {
  --scl--cms-components-switchMedia-default-bg:       #FFFFFF;
  --scl--cms-components-switchMedia-selected-bg:      #8484841A;
  --scl--cms-components-switchMedia-selected-border:  #8A8B8F1A;
  --scl--cms-components-switchMedia-focus-ring:       0px 0px 0px 1px #FFFFFF, 0px 0px 0px 2.5px #0088FF;
  --scl--cms-components-switchMedia-focus-border:     1px solid #8A8B8F;
}

/* ========================================
   WRAPPER
   ======================================== */

.scl--cms-components-switchMedia {
  display: flex;
  flex-direction: row;
  width: 78px;
  height: 34px;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}

.scl--cms-components-switchMedia--disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* ========================================
   BUTTON BASE
   ======================================== */

.scl--cms-components-switchMedia-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 0px;
  gap: 10px;
  width: 39px;
  height: 34px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;
  outline: none;
  position: relative;
  flex-shrink: 0;
}

/* ========================================
   SIDES
   ======================================== */

.scl--cms-components-switchMedia-btn--left {
  border-radius: 4px 0px 0px 4px;
}

.scl--cms-components-switchMedia-btn--right {
  border-radius: 0px 4px 4px 0px;
}

/* ========================================
   STATE: default
   — icon color: var(--input-default)
   ======================================== */

.scl--cms-components-switchMedia-btn--default {
  background: var(--scl--cms-components-switchMedia-default-bg);
  border: none;
  color: var(--input-defualt, #8A8B8F);
}

/* ========================================
   STATE: hover
   — icon color: var(--neutralcolors-700)
   ======================================== */

.scl--cms-components-switchMedia-btn--hover {
  background: var(--scl--cms-components-switchMedia-default-bg);
  border: none;
  color: var(--neutralcolors-700, #353E5C);
}

/* ========================================
   STATE: focus
   — icon color: var(--input-hover)
   ======================================== */

.scl--cms-components-switchMedia-btn--focus {
  background: var(--scl--cms-components-switchMedia-default-bg);
  border: var(--scl--cms-components-switchMedia-focus-border);
  box-shadow: var(--scl--cms-components-switchMedia-focus-ring);
  color: var(--input-hover);
  z-index: 1;
}

/* ========================================
   STATE: selected
   — icon color: var(--input-default)
   ======================================== */

.scl--cms-components-switchMedia-btn--selected {
  background: var(--scl--cms-components-switchMedia-selected-bg);
  border: 1px solid var(--scl--cms-components-switchMedia-selected-border);
  color: var(--input-defualt, #8A8B8F);
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/button-fs-cp/swithc-display-button-op/css/switchMedia.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;;6CAE6C;;AAE7C;EACE,2DAA2D;EAC3D,6DAA6D;EAC7D,6DAA6D;EAC7D,sGAAsG;EACtG,qEAAqE;AACvE;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mGAAmG;EACnG,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;6CAE6C;;AAE7C;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;6CAG6C;;AAE7C;EACE,6DAA6D;EAC7D,YAAY;EACZ,oCAAoC;AACtC;;AAEA;;;6CAG6C;;AAE7C;EACE,6DAA6D;EAC7D,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;;6CAG6C;;AAE7C;EACE,6DAA6D;EAC7D,2DAA2D;EAC3D,6DAA6D;EAC7D,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;6CAG6C;;AAE7C;EACE,8DAA8D;EAC9D,wEAAwE;EACxE,oCAAoC;EACpC,eAAe;AACjB","sourcesContent":["/* switchMedia.css */\n\n/* ========================================\n   LOCAL TOKENS\n   ======================================== */\n\n:root {\n  --scl--cms-components-switchMedia-default-bg:       #FFFFFF;\n  --scl--cms-components-switchMedia-selected-bg:      #8484841A;\n  --scl--cms-components-switchMedia-selected-border:  #8A8B8F1A;\n  --scl--cms-components-switchMedia-focus-ring:       0px 0px 0px 1px #FFFFFF, 0px 0px 0px 2.5px #0088FF;\n  --scl--cms-components-switchMedia-focus-border:     1px solid #8A8B8F;\n}\n\n/* ========================================\n   WRAPPER\n   ======================================== */\n\n.scl--cms-components-switchMedia {\n  display: flex;\n  flex-direction: row;\n  width: 78px;\n  height: 34px;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--cms-components-switchMedia--disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* ========================================\n   BUTTON BASE\n   ======================================== */\n\n.scl--cms-components-switchMedia-btn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 0px;\n  gap: 10px;\n  width: 39px;\n  height: 34px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease;\n  outline: none;\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* ========================================\n   SIDES\n   ======================================== */\n\n.scl--cms-components-switchMedia-btn--left {\n  border-radius: 4px 0px 0px 4px;\n}\n\n.scl--cms-components-switchMedia-btn--right {\n  border-radius: 0px 4px 4px 0px;\n}\n\n/* ========================================\n   STATE: default\n   — icon color: var(--input-default)\n   ======================================== */\n\n.scl--cms-components-switchMedia-btn--default {\n  background: var(--scl--cms-components-switchMedia-default-bg);\n  border: none;\n  color: var(--input-defualt, #8A8B8F);\n}\n\n/* ========================================\n   STATE: hover\n   — icon color: var(--neutralcolors-700)\n   ======================================== */\n\n.scl--cms-components-switchMedia-btn--hover {\n  background: var(--scl--cms-components-switchMedia-default-bg);\n  border: none;\n  color: var(--neutralcolors-700, #353E5C);\n}\n\n/* ========================================\n   STATE: focus\n   — icon color: var(--input-hover)\n   ======================================== */\n\n.scl--cms-components-switchMedia-btn--focus {\n  background: var(--scl--cms-components-switchMedia-default-bg);\n  border: var(--scl--cms-components-switchMedia-focus-border);\n  box-shadow: var(--scl--cms-components-switchMedia-focus-ring);\n  color: var(--input-hover);\n  z-index: 1;\n}\n\n/* ========================================\n   STATE: selected\n   — icon color: var(--input-default)\n   ======================================== */\n\n.scl--cms-components-switchMedia-btn--selected {\n  background: var(--scl--cms-components-switchMedia-selected-bg);\n  border: 1px solid var(--scl--cms-components-switchMedia-selected-border);\n  color: var(--input-defualt, #8A8B8F);\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
